import jwtDecode from "jwt-decode";
import { getCookieTime } from '@/common/js/Cookie.js'
export const GetTokeUserInfo = () => {
  return jwtDecode(getCookieTime("token"));
}